import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import DemoGate, { hasPassedDemoGate } from './DemoGate';
import DemoBanner from './DemoBanner';

// Paths the gate should NOT block (public/auth flows)
const UNGATED_PATHS = [
  '/', '/login', '/register', '/forgot-password', '/reset-password',
  '/verify-email', '/setup-password', '/waiting-for-parent', '/parent-setup',
  '/privacy', '/terms', '/about',
];

/**
 * Wraps the main route tree. When the logged-in user is a demo user, we
 * force them through DemoGate once per session, then render the app with
 * a persistent DEMO banner on every screen.
 */
const DemoShell = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [, setTick] = useState(0); // re-render after unlock

  // Also re-check gate when route changes
  useEffect(() => {
    setTick(t => t + 1);
  }, [location.pathname]);

  if (loading) return children;

  const isDemo = user?.is_demo === true;
  const path = location.pathname;
  const ungated = UNGATED_PATHS.includes(path);

  if (isDemo && !ungated && !hasPassedDemoGate()) {
    return <DemoGate onUnlocked={() => setTick(t => t + 1)} />;
  }

  return (
    <>
      {isDemo && !ungated && <DemoBanner />}
      {children}
    </>
  );
};

export default DemoShell;
